<template>
  <div class="product-content">
    <div
      class="notify fade"
      v-if="notification"
      :class="notification_type"
      @click="notification=false"
    >{{notification}}</div>
    <mq-layout class="container is-boxed-fluid" :mq="['xl', 'hd', 'inf']">
      <div class="page-headline">
        <div class="row ns between">
          <div class="col-6">
            <ul class="breadcrumbs">
              <li v-for="(item, key) in page.data.breadcrumbs">
                <router-link :to="item.slug">{{item.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </mq-layout>

    <div class="container is-boxed-fluid product">
      <div class="row">
        <div class="col-8 col-md-12 product-images" v-if="!page.loading">
          <mq-layout :mq="['md', 'lg', 'xl', 'hd', 'inf']">
            <div class="row gut-2" v-if="page.data.product.meta['gift-cart']!=1">
              <div
                      class="col-6 col-xs-12 product-image"
                      v-for="(image, key) in page.data.product.images"
                      :key="key"
              >
                <div><img :src="image.img_name" alt /></div>
              </div>
            </div>
            <div v-else class="gift-cart-image">
              <img :src="page.data.product.image" alt />
            </div>
          </mq-layout>
          <mq-layout class="mobile-slider" :mq="['xs', 'sm', 'ms']">
            <swiper :options="swiperOption" ref="mySwiper">
              <!-- slides -->
              <swiper-slide v-for="(image, key) in page.data.product.images" :key="key">
                <img :src="image.img_name" alt />
              </swiper-slide>
              <!-- Optional controls -->
              <div class="swiper-prev" slot="button-prev"></div>
              <div class="swiper-next" slot="button-next"></div>
            </swiper>

          </mq-layout>
        </div>
        <div class="col-8 col-md-12 product-images-loading fade" v-if="page.loading">
          <div class="row gut-2">
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
          </div>
        </div>

        <div class="col-4 col-md-12 product-summary fadeUp" v-if="!page.loading">
          <div class="product-info">
            <h1 class="title">{{page.data.product.title}}</h1>
            <div class="price">
              <div class="old-price" v-if="page.data.product.sale"><del>{{page.data.product.regular_price}} {{page.data.product.currency.name}}</del></div>
              <div class="price-list">
                <div class="drop-down bordered">
                  <span>{{page.data.product.price}} {{page.data.product.currency.name}}</span>
                  <div>
                    <ul>
                      <li v-for="(price, key) in page.data.product.price_list" v-if="key!=page.data.product.currency.name"><del v-if="price.sale>0">{{price.regular}} {{key}}</del> <div>~{{price.sale>0 ? price.sale : price.regular}} {{key}}</div></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <p class="sku">{{$t('product_code')}} {{page.data.product.sku}}</p>
            <p class="availability">{{$t('availability')}} <span :class="{not_available: page.data.product.stock <= 0}">{{page.data.product.stock > 0 ? $t('in_stock'):$t('not_available')}}</span></p>
            <div class="attributes">
              <div class v-if="page.data.product.meta.custom=='1'">
                <div class="filter-widget">
                  <h2 class="widget-title">Your text here</h2>
                  <div class="widget-text">
                    <input
                      type="text"
                      v-model="custom_text"
                      :maxlength="10"
                      placeholder="Your Text"
                    />
                    <span class="text-limit">{{10 - custom_text.length}}/10</span>
                  </div>
                </div>
              </div>
              <component
                :is="attribute.component"
                @set_attribute="set_attribute"
                v-for="(attribute) in page.data.product.attributes"
                :key="attribute.id"
                :filter="attribute"
              ></component>
              <color-group :products="page.data.group" v-if="page.data.group"></color-group>
            </div>

            <!--<div class="find-your-size">-->
            <!--<span>Find Your Size</span>-->
            <!--</div>-->
            <div class="add-to-cart">
              <button
                class="button"
                :class="{loading: adding_to_cart}"
                :disabled="adding_to"
                @click="add_to_cart()"
              >{{$t('shop.add_to_cart')}}</button>
            </div>
            <div class="inline-info">
              <span><ins>{{$t('add_to_my_wish_list')}}</ins></span>
              <ul>
                <li><i @click="add_to_favorites()" :class="{'icon-favorited': favorited, 'icon-favorite': !favorited}"></i></li>
              </ul>
            </div>
            <!--<span @click="reset_cart()">RESET CART</span>-->
            <div class="product-tabs">
              <accordion :options="page.data.product.accordion"></accordion>
              <div class="inline-info">
                <span><router-link :to="$i18nRoute({name: 'pages', params: {page: 'return-terms'}})"><ins>{{$t('delivery_information')}}</ins></router-link></span>
              </div>
            </div>
            <div class="inline-info">
              <span>{{$t('share_on_social')}}</span>
              <ul>
                <li><i class="icon-facebook"></i></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-4 col-md-12 prdouct-summary-loading fade" v-if="page.loading">
          <ul>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
          </ul>
        </div>
      </div>
    </div>
    <slider :component="'product'" :items="page.data.rel_products" :title="$t('title.related_products')" :badge="false" :slide_count="4"></slider>
    <slider :component="'product'" :items="page.data.last_views" :title="$t('title.last_views')" :badge="false" :slide_count="4"></slider>

    <div class="backorder-overlay" v-if="backorder_popup"></div>
    <div class="backorder-popup" v-if="backorder_popup">
      <span class="close-popup" @click="backorder_popup=false"></span>
      <div class="request-form-heading">
        <h2>{{$t('backorder.title')}}</h2>
        <p>{{$t('backorder.description')}}</p>
      </div>
      <div class="request-form">
        <div class="form-field">
          <input type="text" v-validate="'required'" name="name" v-model="order.name" :placeholder="$t('backorder.name')">
            <span>{{ errors.first('name') }}</span>
        </div>
        <div class="form-field">
          <input type="text" v-validate="'required|email'" name="email" v-model="order.email" :placeholder="$t('backorder.email')">
            <span>{{ errors.first('email') }}</span>
        </div>
        <div class="form-field">
          <input type="text" v-validate="'required'" name="phone" v-model="order.phone" :placeholder="$t('backorder.phone')">
            <span>{{ errors.first('phone') }}</span>
        </div>
        <div class="form-field">
          <textarea name="message" v-validate="'required'" v-model="order.message" :placeholder="$t('backorder.message')"></textarea>
            <span>{{ errors.first('message') }}</span>
        </div>
        <div class="form-field">
          <input type="hidden" v-model="order.product">
          <button class="button" @click="backorder()" type="button" :disabled="loading" :class="{loading: loading}">{{$t('backorder.make_an_order')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/components/home/Slider.vue';
import Color from '@/components/shop/attributes/Color.vue';
import ColorGroup from '@/components/shop/attributes/ColorGroup.vue';
import Size from '@/components/shop/attributes/Size.vue';
import Listing from '@/components/shop/filters/Listing.vue';
import Accordion from '@/components/global/Accordion.vue';
import Api from '@/services/api-service';
import { mapState } from 'vuex';

export default {
  components: {
    Slider,
    Listing,
    Color,
    ColorGroup,
    Size,
    Accordion
  },
  i18n: {
    messages: {
      en: {
        title: {
          last_views: 'THE LAST THING YOU VIEWED',
          related_products: 'RELATED PRODUCTS'
        },
        backorder: {
          title: 'Unfortunately, this piece of jewelry is not available at this moment.',
          description: 'You can pre-order it now and we will contact you as soon as it is back in stock.',
          name: 'Your name',
          email: 'E-mail',
          phone: 'Phone number',
          message: 'Message',
          make_an_order: 'MAKE AN ORDER',
          bakorder_success: 'Thank you for your order',
          bakorder_error: 'ERROR! Please try again'
        },
        availability: 'Availability:',
        in_stock: 'In stock',
        not_available: 'Not available',
        product_code: 'Product code:'
      },
      hy: {
        title: {
          last_views: 'ՎԵՐՋԻՆ ԴԻՏՎԱԾՆԵՐԸ',
          related_products: 'ՆՄԱՆԱՏԻՊ ԱՊՐԱՆՔՆԵՐ'
        },
        backorder: {
          title: 'Ցավոք զարդը այս պահին առկա չէ',
          description: 'Դուք կարող եք այն պատվիրել և մենք կկապնվենք ձեր հետ երբ այն նորից առկա լինի մեր խանութում',
          name: 'Անուն',
          email: 'Էլ․ Փոստ',
          phone: 'Հեռախոս',
          message: 'Նամակ',
          make_an_order: 'ԿԱՏԱՐԵԼ ՊԱՏՎԵՐ',
          bakorder_success: 'Շնորհակալություն պատվերի համար։ Մենք կարճ ժամանակում կկապնվենք փեզ հետ։',
          bakorder_error: 'Տեղի է ունեցել սխալ։ Փորձեք կրկին։'
        },
        availability: 'Առկայություն՝',
        in_stock: 'Առկա է',
        not_available: 'Առկա չէ',
        product_code: 'Ապրանքի կոդ՝'
      },
      ru: {
        title: {
          last_views: 'Вы смотрели',
          related_products: 'Похожие'
        },
        backorder: {
          title: 'К сожалению на данный момент этого украшение нет в наличии',
          description: 'Оставьте нам сообщение и мы уведомим вас, когда оно снова будет в наличии',
          name: 'Имя',
          email: 'Электронный адрес',
          phone: 'Телефон',
          message: 'Сообщение',
          make_an_order: 'Оформить заказ',
          bakorder_success: 'Спасибо за заказ, в ближайшее время мы с вами свяжемся',
          bakorder_error: 'Ошибка. Попробуйте еще раз'
        },
        availability: 'Наличие',
        in_stock: 'Есть в наличии',
        not_available: 'Нет в наличии',
        product_code: 'Код товара'
      }
    }
  },
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'og:description', content: 'hello' }
    ]
  },
  data () {
    return {
      order: {
        name: '',
        email: '',
        phone: '',
        message: '',
        link: this.$route.fullPath
      },
      loading: false,
      adding_to: false,
      adding_to_cart: false,
      adding_message: '',
      custom_text: '',
      custom_font: 'Roboto-Bold',
      custom_font_size: 125,
      backorder_popup: false,
      swiperOption: {
        slidesPerView: 1,
        centeredSlides: false,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      },
      accordion: [
        {
          title: 'Composition & Care',
          content: 'Content',
          open: false
        },
        {
          title: 'Description',
          content: 'Description',
          open: false
        },
        {
          title: 'Delivery & Returns',
          content: 'Description',
          open: false
        }
      ],
      products: [
        {
          id: 2100,
          image:
            'http://app.nushenamel.am/uploads/products/425/078cb33b1688ae8141e64c9ebab3f8c6.jpeg',
          title: 'Պիջակ «Art Deco»',
          price: '25,000 AMD'
        },
        {
          id: 2101,
          image:
            'http://app.nushenamel.am/uploads/products/425/cfa4eec742ef5a0aebdd1567d2393627.jpeg',
          title: 'Պիջակ «Կաշվի ելևէջներ»',
          price: '22,000 AMD'
        },
        {
          id: 2094,
          image:
            'http://app.nushenamel.am/uploads/products/425/84aa8ddfb52a00459b31bb7991ba3f31.jpeg',
          title: 'Սև շապիկ կարմիր գրպանով',
          price: '19,000 AMD'
        },
        {
          id: 2091,
          image:
            'http://app.nushenamel.am/uploads/products/425/f17d048383111a64d597f4a7e75b2e31.jpeg',
          title: 'Vanity շապիկ',
          price: '18,000 AMD'
        },
        {
          id: 2093,
          image:
            'http://app.nushenamel.am/uploads/products/425/389d47c7805406dea881782e7e603709.jpeg',
          title: 'Շապիկ ջրահարս',
          price: '22,000 AMD'
        },
        {
          id: 2092,
          image:
            'http://app.nushenamel.am/uploads/products/425/530809f8b52269c5f08ccd6d0880f697.jpeg',
          title: 'Շապիկ Inspired by vogue',
          price: '91 000 AMD'
        }
      ],
      notification: false,
      notification_type: 'success',
      add_to_cart_timeout: null,
      notification_timeout: null,
      selected_attributes: {},
      favorited: false
    };
  },
  created () {
    this.$store.dispatch('fetchLastViews', this.$route.params.product);
    this.favorited = !!this.$store.getters.getFavoriteItem(this.$route.params.product);
  },
  methods: {
    notify (notification, type = 'success', time = 1500) {
      var self = this;
      self.notification = notification;
      self.notification_type = type;
      clearTimeout(this.notification_timeout);
      self.notification_timeout = setTimeout(function () {
        self.notification = false;
      }, time);
    },
    reset_cart () {
      this.$store.dispatch('resetCart');
    },
    generate_cart_item_id () {
      // eslint-disable-next-line camelcase
      var selected_attrs = [];
      if (Object.keys(this.selected_attributes).length > 0) {
        for (var key in this.selected_attributes) {
          selected_attrs.unshift(this.selected_attributes[key].id);
        }
      } else {
        selected_attrs.push(this.page.data.product.id);
      }
      return selected_attrs.join('-');
    },
    set_attribute (option, key) {
      this.selected_attributes[key] = {
        id: option.id,
        value: option.key
      };
    },
    save_cart_item () {
      if (!this.adding_to) {
        var self = this;
        this.adding_to = true;
        this.adding_to_cart = true;
        this.adding_message = 'Added to cart';
        this.page.data.product.qty = 1;

        // eslint-disable-next-line camelcase
        let cart_item = {
          qty: 1,
          item_id: this.generate_cart_item_id(),
          product_id: this.page.data.product.id,
          sku: this.page.data.product.sku,
          stock: this.page.data.product.stock,
          title: this.page.data.product.title,
          price: this.page.data.product.price,
          image: this.page.data.product.image,
          giftCart: this.page.data.product.meta['gift-cart'],
          attributes: Object.assign({}, this.selected_attributes)
        };

        this.$store.dispatch('fetchCartItem', cart_item);
        clearTimeout(this.add_to_cart_timeout);
        this.add_to_cart_timeout = setTimeout(function () {
          self.adding_to = false;
          self.adding_to_cart = false;
          self.notify('Added to cart', 'success', 3000);
        }, 500);
      }
    },
    add_to_cart () {
      if (Number(this.page.data.product.stock) > 0) {
        // eslint-disable-next-line camelcase
        var current_product_attributes_count = Object.keys(
          this.page.data.product.attributes
        ).length;
        // eslint-disable-next-line camelcase
        var selected_attributes_count = Object.keys(this.selected_attributes).length;

        // eslint-disable-next-line camelcase
        if (current_product_attributes_count > 0) {
          // eslint-disable-next-line camelcase
          if (selected_attributes_count === current_product_attributes_count) {
            this.save_cart_item();
          } else {
            for (var key in this.page.data.product.attributes) {
              if (
                !this.selected_attributes.hasOwnProperty(
                  this.page.data.product.attributes[key].name
                )
              ) {
                this.notify(
                  this.page.data.product.attributes[key].name + ' not selected',
                  'error',
                  5000
                );
                break;
              }
            }
          }
        } else {
          this.save_cart_item();
        }
      } else {
        this.backorder_popup = true;
      }
    },
    add_to_favorites () {
      if (!this.adding_to) {
        var self = this;
        self.adding_to = true;
        self.adding_message = 'Added to favorites';
        self.$store.dispatch('fetchFavoriteItem', self.page.data.product.id);
        self.favorited = !!self.$store.getters.getFavoriteItem(self.$route.params.product);
        clearTimeout(this.add_to_cart_timeout);
        self.add_to_cart_timeout = setTimeout(function () {
          self.adding_to = false;
          self.notify('Added to favorites', 'success', 1500);
        }, 300);
      }
    },
    change_font_size (step) {
      this.custom_font_size = step
        ? this.custom_font_size + 5
        : this.custom_font_size - 5;
      if (this.custom_font_size < 100) {
        this.custom_font_size = 100;
      } else if (this.custom_font_size > 150) {
        this.custom_font_size = 150;
      }
    },
    backorder () {
      if (!this.loading) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.loading = true;
            Api.post('/product/backorder', { data: this.order })
              .then(response => {
                this.loading = false;
                this.backorder_popup = false;
                if (response.data.status === 'success') {
                  this.order = {
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    link: this.$route.fullPath
                  };
                  this.$validator.reset();
                  this.notify(this.$t('backorder.bakorder_success'), 'success', 8000);
                } else {
                  this.notify(this.$t('backorder.bakorder_error'), 'error', 8000);
                }
              })
              .catch(error => {
                this.loading = false;
                this.notify(this.$t('backorder.bakorder_error') + error, 'error', 8000);
              });
          }
        });
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('fetchPage', {
      product: {}
    });
  },
  computed: mapState(['page'])
};
</script>

<style lang="scss">
.product-content {
  padding-top: 75px;
  position: relative;

  @include mq($ms){
    padding-top: 55px;
  }

  .shop-headline {
    margin-bottom: 30px;
  }

  .widget-text {
    max-width: 365px;
    position: relative;
    input {
      width: 100%;
      height: 60px;
      padding-left: 15px;
      font-size: 16px;
      & + span {
        display: block;
        position: absolute;
        right: 15px;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 60px;
        line-height: 60px;
        width: 40px;
        text-align: center;
        font-size: 14px;
      }
    }
  }

  .widget-font {
    max-width: 365px;
    position: relative;
    select {
      width: 100%;
      height: 60px;
      font-size: 16px;
      padding-left: 15px;
      -webkit-appearance: none;
      position: relative;
      z-index: 2;
      background: transparent;
      & + span {
        position: absolute;
        display: block;
        right: 15px;
        top: 0;
        bottom: 0;
        margin: auto;
        line-height: 60px;
        font-size: 8px;
        z-index: 1;
      }
    }
  }

  .widget-font-size {
    width: 160px;
    display: flex;
    border: 1px solid #000;
    user-select: none;
    span {
      display: block;
      width: 40px;
      line-height: 60px;
      font-size: 24px;
      height: 60px;
      text-align: center;
      cursor: pointer;
    }
    div {
      width: 80px;
      height: 60px;
      line-height: 60px;
      border: 0;
      outline: none;
      font-size: 16px;
      text-align: center;
    }
  }

  .product {
    margin-bottom: 90px;

    @include mq($ms){
      margin-bottom: 15px;
    }

    .product-images {

      @include mq($ms){
        padding-left: 0;
        padding-right: 0;
        min-height: 500px;
      }

      &>div{
        height: 100%;
      }

      .gift-cart-image{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding-top: 120px;
        padding-bottom: 120px;
        background: #f5fcfd;
        img{
          width: 100%;
          max-width: 550px;
        }
      }

      .product-image{
        &>div{
          position: relative;
          &:before{
            content: "";
            display: block;
            padding-top: 100%;
          }
          img{
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .custom-made {
        width: 550px;
        margin: auto;
        position: relative;

        .custom-text {
          width: 240px;
          padding: 20px 15px;
          text-align: center;
          font-size: 30px;
          color: #000;
          border: 1px solid #2e6fd1;
          position: absolute;
          top: 130px;
          left: 140px;
        }
      }
      img {
        display: block;
        width: 100%;
      }
    }
    .product-summary {
      .product-info {
        position: sticky;
        top: 120px;
      }
      h1 {
        margin-top: 0;
        font-size: 24px;
        font-family: $font-bold;
        margin-bottom: 15px;

        @include mq($ms){
          font-size: 18px;
        }
      }
      p {
        margin: 0;
      }
      .price {
        font-size: 24px;
        font-family: $font-bold;
        margin-bottom: 15px;
        @include mq($ms){
          font-size: 18px;
        }
      }
      .sku, .availability {
        font-size: 14px;
        color: #919191;
        margin-bottom: 10px;
      }

      .availability{
        span{
          color: green;
          &.not_available{
            color: red;
          }
        }
      }

      .attributes {
        .filter-widget {
          margin-top: 30px;

          @include mq($ms){
            margin-top: 15px;
          }
        }
      }

      .find-your-size {
        margin-top: 15px;
        span {
          cursor: pointer;
          text-decoration: underline;
          font-family: $font-bold;
          font-size: 16px;
        }
      }

      .add-to-cart {
        display: flex;

        button{
          width: 100%;
          max-width: 360px;
        }

        @include mq($ms){
          margin-top: 0;
        }

        .favorite {
          width: 85px;
          height: 60px;
          margin-left: 1px;
          line-height: 60px;
          font-size: 20px;
        }
      }

      .product-tabs{
        margin-bottom: 30px;
        .accordion {
          margin: inherit;
          margin-top: 20px;
          margin-bottom: 15px;
          max-width: 360px;

          @include mq($ms){
            margin-top: 0;
            margin-bottom: 15px;
          }

          .accordion-title{
            font-size: 16px;
          }
          .accordion-content{
            font-size: 14px;
          }
        }
      }

      .inline-info {
        align-items: center;
        display: flex;
        @include mq(false, $ms){
          margin-top: 15px;
        }
        span {
          font-size: 16px;
          font-family: $font-bold;
          margin-right: 20px;
        }
        ul {
          display: flex;
          li {
            cursor: pointer;
            margin-right: 15px;
            height: 25px;
            i {
              font-size: 24px;
              &.icon-favorited:before{
                color: $main-color;
              }
            }
          }
        }
      }
    }

    .prdouct-summary-loading {
      ul {
        max-width: 70%;
        li {
          height: 20px;
          margin-bottom: 15px;
          animation: gradient 0.7s infinite;
          &:nth-child(1) {
            width: 80%;
          }
          &:nth-child(2) {
            width: 60%;
          }
          &:nth-child(3) {
            width: 75%;
          }
          &:nth-child(4) {
            width: 100%;
          }
          &:nth-child(5) {
            width: 68%;
          }
          &:nth-child(6) {
            width: 61%;
          }
          &:nth-child(7) {
            width: 75%;
          }
          &:nth-child(8) {
            width: 85%;
          }
        }
      }
    }

    .product-images-loading {
      .loading {
        animation: gradient 0.7s infinite;
        height: 650px;

        @include mq($ms){
          height: 500px;
        }
      }
      @include mq($ms){
        .col-6{
          padding: 0;
          &:not(:last-child){
            display: none;
          }
        }
      }
    }
  }

  .backorder-overlay{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 99999;
  }
  .backorder-popup{
    width: 80%;
    max-width: 500px;
    margin: auto;
    background: #fff;
    padding: 50px 30px 30px 30px;
    position: fixed;
    top: 100px;
    left: 0;
    right: 0;
    z-index: 999999;

    .close-popup{
      display: block;
      width: 26px;
      height: 26px;
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 15px;
      &:after, &:before{
        content: "";
        display: block;
        border-bottom: 1px solid #1A1818;
        top: 13px;
        position: relative;
      }
      &:after{
        transform: rotate(45deg);
      }
      &:before{
        transform: rotate(-45deg);
      }
    }

    .request-form-heading{
      padding: 0 30px;
      h2{
        margin-top: 0;
        text-align: center;
        font-size: 24px;
      }
      p{
        margin-top: 0;
        text-align: center;
        font-size: 16px;
      }
    }

    .request-form{
        height: 500px;
        overflow-y: auto;
      .form-field{
        &:not(:last-child){
          margin-bottom: 15px;
        }
        input{
          width: 100%;
          height: 50px;
          padding: 0 10px;
          @include placeholder{
            font-family: $font-regular;
            font-size: 14px;
          }
        }
        textarea{
          width: 100%;
          height: 100px;
          resize: none;
          padding: 10px;
          @include placeholder{
            font-family: $font-regular;
            font-size: 14px;
          }
        }
        .button{
          width: 100%;
        }
      }
    }
  }
}
</style>
